export const apiURL = process.env.REACT_APP_API_URL;
export const insightsURL = process.env.REACT_APP_INSIGHTS_URL;
export const bChatURL = process.env.REACT_APP_BCHAT_URL;
export const bIntegrationsURL = process.env.REACT_APP_BINTEGRATIONS_URL;
export const encryptionKey = process.env.REACT_APP_ENCRYPTION_KEY;
export const merakiUrl = process.env.REACT_APP_MERAKI_URL;
export const airshipUrl = process.env.REACT_APP_AIRSHIP_URL;
export const unifiUrl = process.env.REACT_APP_UNIFI_URL;
export const tplinkUrl = process.env.REACT_APP_TPLINK_URL;
export const metaUrl = process.env.REACT_APP_META_URL;
export const atreemoUrl = process.env.REACT_APP_ATREEMO_URL;
export const klaviyoUrl = process.env.REACT_APP_KLAVIYO_URL;
export const brevoUrl = process.env.REACT_APP_BREVO_URL;
export const leatUrl = process.env.REACT_APP_LEAT_URL;
export const sevenroomsUrl = process.env.REACT_APP_SEVENROOMS_URL;
export const brazeUrl = process.env.REACT_APP_BRAZE_URL || apiURL?.replace(/api\/v1\/?$/, "bBraze/");
export const bloomreachUrl = process.env.REACT_APP_BLOOMREACH_URL || apiURL?.replace(/api\/v1\/?$/, "bBloomreach/");
export const eatAppUrl = process.env.REACT_APP_EAT_APP_URL || apiURL?.replace(/api\/v1\/?$/, "bEatApp/");
export const mcpUrl = apiURL?.replace(/api\/v1\/?$/, "bMcp/");
export const comoUrl = process.env.REACT_APP_COMO_URL;
export const googleAdsUrl = process.env.REACT_APP_GOOGLE_ADS_URL;
export const reviewsUrl = process.env.REACT_APP_REVIEWS_URL;
export const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
export const bMarketingUrl = process.env.REACT_APP_BMARKETING_URL;
export const bSurveysUrl = process.env.REACT_APP_BSURVEYS_URL;
export const dotdigitalUrl = process.env.REACT_APP_DOTDIGITAL_URL;
